// extracted by css-extract-rspack-plugin
export default {"container":"IndexParameter-module__container__LDL0C","label":"IndexParameter-module__label__5myar"};